import { useState, Dispatch, SetStateAction } from 'react';

export const useTimeState = <S>({
  defaultValue,
  value: externalValue,
}: {
  defaultValue: S;
  value: S;
}): [S, Dispatch<SetStateAction<S>>] => {
  const [value, setValue] = useState<S>(defaultValue);

  return [externalValue || value, setValue];
};
